import React, { useState } from 'react';
import Image from 'next/image';
import styles from './StateFlag.module.css';

export interface StateFlagProps {
    state: string; // e.g., "ustx"
    size?: number; // pixel size
    className?: string;
}

const getStateFlagFileName = (normalizedState: string): string => {
    return `us${normalizedState.toLowerCase()}.svg`;
};

export const StateFlag: React.FC<StateFlagProps> = ({
    state,
    size = 32,
    className
}) => {
    const [imgError, setImgError] = useState(false);
    const fileName = getStateFlagFileName(state);
    return (
        <span className={`${styles.stateFlagWrapper}${className ? ` ${className}` : ''}`}>
            {!imgError && (
                <Image
                    src={`/images/us_state_flags/${fileName}`}
                    alt={`${state} flag`}
                    width={size}
                    height={size}
                    style={{ 
                        display: 'inline-block', 
                        objectFit: 'cover',
                        width: size,
                        height: 'auto'
                    }}
                    onError={() => setImgError(true)}
                    unoptimized // Required for SVGs
                />
            )}
            <span className={styles.stateCode}>{state}</span>
        </span>
    );
}; 